import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './Tab.module.css';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { patientActions } from '_actions';
import { PatientDot } from '_components';


class PatientTab extends React.Component {

    constructor() {
        super();
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose(event) {
        this.props.closePatient(this.props.patient.id);
        event.stopPropagation();
    }

    render() {
        if (this.props.patient) {
            return (
                <span
                    key={this.props.patient.id}
                    className={styles.tab + ' ' + (this.props.selected ? styles.tab_selected : '')}
                    onClick={() => this.props.setPatientActive(this.props.patient.id)}>
                    <span className={styles.tab_contents}>
                        <span className={styles.tab_contents_dot}>
                            <PatientDot id={this.props.patient.dot} />
                        </span>
                        <span
                            className={styles.tab_contents_name + ' ' + (this.props.patient.isFederal ? styles.federal : '')}
                            title={this.props.patient.firstName + ' ' + this.props.patient.lastName}>
                            {this.props.patient.loading ? 'Loading...' : this.props.patient.firstName + ' ' + this.props.patient.lastName}
                        </span>
                        <span title="Close Patient" className={styles.close} onClick={this.handleClose}>
                            <FontAwesomeIcon icon={faTimesCircle} />
                        </span>
                    </span>
                </span>
            )
        } else {
            return (null);
        }
    };
}

function mapStateToProps(state, ownprops) {
    return {
        patient: state.entities.patients[ownprops.id]
    };
}


function mapDispatchToProps(dispatch) {
    return {
        setPatientActive: bindActionCreators(patientActions.setActive, dispatch),
        closePatient: bindActionCreators(patientActions.close, dispatch)
    };
}

const connectedPatientTab = connect(mapStateToProps, mapDispatchToProps)(PatientTab);
export { connectedPatientTab as PatientTab };

